import React, { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import { Notifications } from '@mui/icons-material';
import { hasNotificationsConsent } from '../../../utils/cookieUtils';
import { CANNY_ENABLED, hasUnseenCannyEntries, initCanny } from '../../../hooks/useCanny';

const CANNY_APP_ID = process.env.REACT_APP_ENV_NAME === 'prod' || process.env.REACT_APP_ENV_NAME === "demo"
  ? '688780adbe67c13d05c1470e'
  : '6863bbdcd31852b4e2d4d488';

const CannyChangelogWidget = () => {
  const [hasConsent, setHasConsent] = useState(() => hasNotificationsConsent());

  // React to consent changes dispatched by cookieUtils (same-tab, no reload needed)
  useEffect(() => {
    const onConsentChange = () => setHasConsent(hasNotificationsConsent());
    window.addEventListener('cookie-consent-changed', onConsentChange);
    return () => window.removeEventListener('cookie-consent-changed', onConsentChange);
  }, []);

  // Init/re-init Canny whenever consent becomes true — at this point the button is in the DOM
  useEffect(() => {
    // Skip SDK init while Canny is temporarily disabled.
    if (!CANNY_ENABLED || !hasConsent) return;

    let cancelled = false;

    const setupCanny = async () => {
      const initialized = await initCanny(CANNY_APP_ID);
      if (!initialized || cancelled) return;

      setTimeout(() => {
        const hasUnseen = hasUnseenCannyEntries();
        if (hasUnseen) {
          const btn = document.getElementById('cannChangeLogNotificationButton');
          if (btn) btn.click();
        }
      }, 1000);
    };

    setupCanny();
    return () => { cancelled = true; };
  }, [hasConsent]);

  // Hide the changelog button entirely while Canny is temporarily disabled.
  if (!CANNY_ENABLED || !hasConsent) {
    return null;
  }

  return (
    <IconButton
      id='cannChangeLogNotificationButton'
      data-canny-changelog
      sx={{
        position: 'fixed !important',
        bottom: 16,
        right: 16,
        bgcolor: '#AF3241',
        color: '#fff',
        boxShadow: 3,
        '&:hover': {
          bgcolor: '#AF3241',
        },
        zIndex: 1000,
      }}
    >
      <Notifications />
    </IconButton>
  );
};

export default CannyChangelogWidget;
